
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class CAudioView extends Vue {
  @Prop() private url!: string;

  private audioUrl = this.$api.cdn_url + this.url;

  protected created() {
    this.changeUrl();
  }

  @Watch("url")
  protected changeUrl() {
    this.audioUrl = RegExp(this.$api.regex_url).test(this.url)
      ? this.url
      : this.$api.cdn_url + this.url;
  }
}
